import { formatDataValue } from 'utils/formatFns';

export const regulatoryInformation = {
  transmissionSource: {
    label: 'Transmission Source',
    getValue: (data) => data?.generalInfo?.regulatoryInformation?.transmissionSource,
    formatValue: (value) => formatDataValue({ value }),
  },
};
